import { Midi } from "@tonejs/midi";

export const MIDI_DRUM_CHANNEL = 9;
export const MIDI_EXPORT_NOTICE_DISMISSED_KEY = "bardsCorner.midiExport.noticeDismissed.v1";

export function createMidiDocument({
  name,
  ppq = 960,
  bpm = 120,
  timeSignature = [4, 4],
  keySignature = null,
} = {}) {
  const midi = new Midi();
  const header = midi.header.toJSON();
  midi.header.fromJSON({
    ...header,
    name: String(name || "Bard's Corner Export"),
    ppq,
    tempos: [{ ticks: 0, bpm }],
    timeSignatures: [{ ticks: 0, timeSignature }],
    keySignatures: keySignature ? [{ ticks: 0, ...keySignature }] : [],
  });
  return midi;
}

export function addMidiTrack(midi, { name, channel = 0, instrumentNumber = 0 } = {}) {
  const track = midi.addTrack();
  track.name = String(name || "Track");
  track.channel = channel;
  track.instrument.number = instrumentNumber;
  return track;
}

export function addMidiNote(track, { midi, ticks, durationTicks, velocity = 0.72 }) {
  const midiNumber = Math.round(Number(midi));
  const startTicks = Math.max(0, Math.round(Number(ticks) || 0));
  const safeDurationTicks = Math.max(1, Math.round(Number(durationTicks) || 1));
  if (!Number.isFinite(midiNumber) || midiNumber < 0 || midiNumber > 127) {
    return;
  }

  track.addNote({
    midi: midiNumber,
    ticks: startTicks,
    durationTicks: safeDurationTicks,
    velocity: normalizeMidiVelocity(velocity),
  });
}

export function downloadMidi(midi, title) {
  const bytes = midi.toArray();
  const blob = new window.Blob([bytes], { type: "audio/midi" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${midiFilenameStem(title)}.mid`;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

export function shouldShowMidiExportNotice() {
  try {
    return window.localStorage.getItem(MIDI_EXPORT_NOTICE_DISMISSED_KEY) !== "1";
  } catch {
    return true;
  }
}

export function rememberMidiExportNoticeDismissed() {
  try {
    window.localStorage.setItem(MIDI_EXPORT_NOTICE_DISMISSED_KEY, "1");
  } catch {
    // Ignore private browsing or storage quota issues.
  }
}

function normalizeMidiVelocity(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return 0.72;
  }
  return Math.max(0.01, Math.min(1, number > 1 ? number / 127 : number));
}

function midiFilenameStem(title) {
  const safe = String(title || "")
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "")
    .replace(/\s+/g, " ")
    .slice(0, 120);
  return safe || "bards-corner-export";
}
